export default "__VITE_ASSET__CueJpLtO__"